(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meluvi-pdp-materials"] && !Shopify.designMode) return;
  try {
    
  if (!window.meluviCertificateModalsBound) {
    window.meluviCertificateModalsBound = true;

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-meluvi-cert-open]');
      if (opener) {
        var modal = document.getElementById(opener.getAttribute('data-meluvi-cert-open'));
        if (modal && typeof modal.showModal === 'function') modal.showModal();
        return;
      }

      var closer = event.target.closest('[data-meluvi-cert-close]');
      if (closer) {
        var openModal = closer.closest('dialog');
        if (openModal) openModal.close();
        return;
      }

      if (event.target.matches('dialog.meluvi-cert-modal')) event.target.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meluvi-pdp-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function findDocs() {
      var doc = document.querySelector('[data-mlv-docs]');
      return doc ? doc.closest('details') : null;
    }

    function syncButtons() {
      var details = findDocs();
      document.querySelectorAll('[data-mlv-open-docs]').forEach(function (button) {
        button.hidden = !details;
      });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-mlv-open-docs]');
      if (!button) return;
      var details = findDocs();
      if (!details) return;
      event.preventDefault();
      if (!details.open) {
        var summary = details.querySelector('summary');
        if (summary) summary.click();
        if (!details.open) details.open = true;
      }
      details.style.scrollMarginTop = '110px';
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncButtons);
    } else {
      syncButtons();
    }
    document.addEventListener('shopify:section:load', syncButtons);
  })();

  } catch(e) { console.error(e); }
})();
})();
